import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DecimalWrapperPipe } from './decimal-wrapper/decimal-wrapper.pipe';
import { StringClippingPipe } from './string-clipping/string-clipping.pipe';
import { HCurrecyPipe } from './hcurrency.pipe';
import { FilterPipe } from './filter/filter.pipe';
import { BeneficiaryCheckStatusPipe } from './beneficiary-check-status.pipe';
import { BeneficiaryCheckDescriptionPipe } from './beneficiary-check-description.pipe';

@NgModule({
   imports: [
      CommonModule
   ],
   declarations: [
      DecimalWrapperPipe,
      StringClippingPipe,
      HCurrecyPipe,
      FilterPipe,
      BeneficiaryCheckStatusPipe,
      BeneficiaryCheckDescriptionPipe
   ],
   exports: [
      DecimalWrapperPipe,
      StringClippingPipe,
      HCurrecyPipe,
      FilterPipe,
      BeneficiaryCheckStatusPipe,
      BeneficiaryCheckDescriptionPipe,
   ],
})
export class PipesModule {
}
